<template>
  <div class="publish-content popup">
    <a class="close-x" @click="cancelPopup">
      <img class="close-icon" src="@/assets/images/close_icon.svg" alt="">
    </a>
    <h2 class="title">
      <span>{{ $t("CONFIRM_SHOULD_PUBLISH_LESSON_NAMED") }}</span>
      <span>{{'"' + collectionTitle + '"'}}</span>
    </h2>
    <div class="bounce-animation">
      <img src="@/assets/images/siman-kriya-green.svg" alt="" class="image">
    </div>
    <div class="buttons-wrap">
      <button class="common-button cancel-button" @click="cancelPopup">
        {{ $t("CANCEL") }}
      </button>
        <button class="common-button publish-button" @click="publishLesson">
        {{ $t("PUBLISH") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'publish-popup',
  props: {
    collectionTitle: {
      type: String
    }
  },
  methods: {
    cancelPopup () {
      this.$emit('close-popup')
    },
    publishLesson () {
      this.$emit('approve-popup-function', { action: 'approved' })
    }
  }
}
</script>

<style >

</style>
